export default {
  name: [],
  description: [],
  orderedReferenceList: [],
  curatedMediaLists: [],
  curatedSeriesLists: [],
  owner: [],
  id: [],
  created: [],
  updated: [],
  deleted: [],
  version: [],
  lastUpdatedBy: [],
  highlightSeriesId: [],
  processedSeries: [],
  processedMedia: [],
}
